module.exports = __webpack_public_path__ + "static/media/city_1.ccdc3a7a.jpg";